<template>
  <svg v-if="direction === 'left'" :width="width" :height="height" :viewBox="viewBox" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Arrow Left</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-359.000000, -1457.000000)">
        <g transform="translate(359.000000, 1457.000000)">
          <circle stroke="#F1E6B2" stroke-width="2" cx="30" cy="30" r="29"></circle>
          <path d="M27.7071068,23.2928932 L33.3455714,28.9291741 C33.3517588,28.9350572 33.3578895,28.9410348 33.3639615,28.9471068 C33.5141631,29.0973084 33.6065949,29.2834037 33.6412568,29.4777821 C33.6967155,29.7914282 33.6042837,30.1236384 33.363961,30.363961 L33.344,30.38 L27.7071072,36.0181746 C27.3165829,36.4086989 26.6834179,36.4086989 26.2928937,36.0181746 C25.9023694,35.6276503 25.9023694,34.9944853 26.2928937,34.603961 L31.241,29.655 L26.2928932,24.7071068 C25.9023689,24.3165825 25.9023689,23.6834175 26.2928932,23.2928932 C26.6834175,22.9023689 27.3165825,22.9023689 27.7071068,23.2928932 Z" id="Combined-Shape-Copy-2" fill="#880D27" transform="translate(29.828427, 29.655534) scale(-1, 1) translate(-29.828427, -29.655534) "></path>
        </g>
      </g>
    </g>
  </svg>
  <svg v-else :width="width" :height="height" :viewBox="viewBox" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Arrow Right</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-1500.000000, -1459.000000)">
        <g transform="translate(1500.000000, 1459.000000)">
          <circle stroke="#F1E6B2" stroke-width="2" transform="translate(30.000000, 30.000000) scale(-1, 1) translate(-30.000000, -30.000000) " cx="30" cy="30" r="29"></circle>
          <path d="M27.7071068,23.2928932 L33.3455714,28.9291741 C33.3517588,28.9350572 33.3578895,28.9410348 33.3639615,28.9471068 C33.5141631,29.0973084 33.6065949,29.2834037 33.6412568,29.4777821 C33.6967155,29.7914282 33.6042837,30.1236384 33.363961,30.363961 L33.344,30.38 L27.7071072,36.0181746 C27.3165829,36.4086989 26.6834179,36.4086989 26.2928937,36.0181746 C25.9023694,35.6276503 25.9023694,34.9944853 26.2928937,34.603961 L31.241,29.655 L26.2928932,24.7071068 C25.9023689,24.3165825 25.9023689,23.6834175 26.2928932,23.2928932 C26.6834175,22.9023689 27.3165825,22.9023689 27.7071068,23.2928932 Z" id="Combined-Shape-Copy-2" fill="#880D27"></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "heroHomepageArrow",
  props: {
    direction: String,
    color: String,
  },
  computed: {
    size() {
      return 60;
    },
    height() {
      return this.size + 'px';
    },
    width() {
      return this.size + 'px';
    },
    viewBox() {
      return "0 0 " + this.size + " " + this.size;
    },
  }
}
</script>

